import { Row } from 'react-styled-flexboxgrid';
import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $PaymentContainer = styled('div')`
  padding: ${spacing('lg')};

  @media ${media.minWidth.sm} {
    padding: ${spacing('xxl')};
  }

  border: 1px solid ${({ theme }) => theme.colors.default};
  border-radius: ${({ theme }) => theme.tw.radius.lg};
`;

export const $PaymentButtonContainer = styled('div')`
  margin-top: ${spacing('lg')};
`;

export const $PaymentInputContainer = styled(Row)`
  margin-bottom: ${spacing('md')};
`;
